<div class="ng-scope">
    <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="#">Disputes</a>
    </nav>

    <div class="container-fluid" style="margin-bottom: 1em; padding-left: 0; padding-right: 0;">
        <form class="example-form">
            <div class="card">
                <div class="card-header">
                    <button class="btn ng-binding" style="float: right;" (click)="toggle()">
                        {{buttonName}}
                    </button>
                </div>

                <div class="card-body animate-show-hide" id="filterGroup" *ngIf="ShowFilters">
                    <div class="row">
                        <div class="col-sm-3">
                            <b>
                                Tracking No./Loan No.
                            </b>
                        </div>

                        <div class="col-sm-9">
                            <mat-form-field appearance="fill">
                                <input matInput type="number">
                            </mat-form-field>
                        </div>

                        <div class="row">
                            <div class="col-sm-3" style="margin-top: 2em;">
                                <b>
                                    Disputes Type
                                </b>
                            </div>


                            <div class="col-sm-9" style="margin-top: 2em;">
                                <mat-form-field appearance="fill">
                                    <mat-label>select</mat-label>
                                    <mat-select>
                                        <mat-option *ngFor="let cust of custs" [value]="cust.value">
                                            {{cust.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        
                        <div class="row" style="margin-top: 3em;">
                            <div class="col-sm-2">
                                <mat-button ng-click="$ctrl.searchClicked()" type="button" class="btn btn-primary">
                                    SEARCH
                                </mat-button>
                            </div>

                            <div class="col-sm-10">
                                <button type="reset" class="btn btn-primary">
                                    RESET
                                </button>
                            </div>
                        </div>
                    </div>